var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "index-con" },
    [
      _c(
        "el-aside",
        {
          class: _vm.showclass,
          staticStyle: {
            transition: "all 0.7s",
            "border-right": "1px solid #f5f5f5"
          }
        },
        [
          _c("div", { staticClass: "logo" }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showclass == "asideshow",
                  expression: "showclass == 'asideshow'"
                }
              ],
              staticStyle: { width: "80px" },
              attrs: {
                src: require("@/assets/img/group_logo.png"),
                alt: "客莱宝"
              }
            }),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showclass == "aside",
                  expression: "showclass == 'aside'"
                }
              ],
              staticStyle: { width: "26px" },
              attrs: {
                src: require("@/assets/img/group_logo2.png"),
                alt: "客莱宝"
              }
            })
          ]),
          _c(
            "div",
            {
              staticStyle: {
                flex: "1",
                "overflow-y": "scroll",
                "overflow-x": "hidden"
              }
            },
            [_c("Leftnav", { attrs: { user: _vm.user } })],
            1
          ),
          _c(
            "div",
            { staticClass: "aside-bottom" },
            [
              _c("el-button", {
                staticClass: "buttonimg",
                attrs: { icon: _vm.collapsed ? _vm.iconOpen : _vm.iconClose },
                on: {
                  click: function($event) {
                    return _vm.toggle(_vm.collapsed)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-container",
        { staticClass: "main-con" },
        [
          _c(
            "el-header",
            { staticClass: "index-header" },
            [_c("Navcon1", { attrs: { user: _vm.user } })],
            1
          ),
          _c(
            "el-header",
            { staticClass: "tags-container" },
            [_c("TagsView")],
            1
          ),
          _c(
            "el-main",
            {
              staticClass: "index-main",
              staticStyle: { "background-color": "#F4F7FC" },
              attrs: { id: "indexMain" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "main-wrap",
                  class: _vm.key == "/index" ? "index-style" : ""
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade-transform", mode: "out-in" } },
                    [
                      _c(
                        "keep-alive",
                        [
                          _vm.isKeepAlive
                            ? _c("router-view", { key: _vm.key })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fade-transform", mode: "out-in" } },
                    [
                      !_vm.isKeepAlive
                        ? _c("router-view", { key: _vm.key })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }